import React from 'react';

import { ProductGrid } from '@components/components';

import Styles from './MainProductsGrid.module.scss';

export const MainProductsGrid: React.FC = () => {
  return <ProductGrid parameters={{ className: Styles.productItemClassName, listName: 'category' }} />;
};
